shadow$provide[107] = function(require,module,exports) {
var require$_DOT__DOT__SLASH_bootstrap = require("../bootstrap");
require$_DOT__DOT__SLASH_bootstrap.Bootstrap.registerPlugin("fallback", {defaults:{force:false, fill:true, begin:'\x3cdiv class\x3d"threestrap-fallback" style\x3d"display: table; width: 100%; height: 100%;' + 'box-sizing: border-box; border: 1px dashed rgba(0, 0, 0, .25);"\x3e' + '\x3cdiv style\x3d"display: table-cell; padding: 10px; vertical-align: middle; text-align: center;"\x3e', end:"\x3c/div\x3e\x3c/div\x3e", message:"\x3cbig\x3e\x3cstrong\x3eThis example requires WebGL\x3c/strong\x3e\x3c/big\x3e\x3cbr\x3e" + 
'Visit \x3ca target\x3d"_blank" href\x3d"http://get.webgl.org/"\x3eget.webgl.org\x3c/a\x3e for more info\x3c/a\x3e',}, install:function(three) {
  let cnv, gl;
  try {
    cnv = document.createElement("canvas");
    gl = cnv.getContext("webgl") || cnv.getContext("experimental-webgl");
    if (!gl || this.options.force) {
      throw "WebGL unavailable.";
    }
    three.fallback = false;
  } catch (e) {
    const message = this.options.message;
    const begin = this.options.begin;
    const end = this.options.end;
    const fill = this.options.fill;
    const div = document.createElement("div");
    div.innerHTML = begin + message + end;
    this.children = [];
    while (div.childNodes.length > 0) {
      this.children.push(div.firstChild);
      three.element.appendChild(div.firstChild);
    }
    if (fill) {
      three.install("fill");
    }
    this.div = div;
    three.fallback = true;
    return false;
  }
}, uninstall:function(three) {
  if (this.children) {
    this.children.forEach(function(child) {
      child.parentNode.removeChild(child);
    });
    this.children = null;
  }
  delete three.fallback;
},});

};